// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

Rails.start()
Turbolinks.start()
ActiveStorage.start()

require('admin-lte');
require("jquery");

import 'bootstrap';
import "@fortawesome/fontawesome-free/js/all";
require("trix")
require("@rails/actiontext")

// 各モジュールをインポート
import { handleSwiperTurbolinks } from '../modules/swiper_handler';
import { handleMenuTurbolinks } from '../modules/menu_handler';
import { handlePopupTurbolinks } from '../modules/popup_handler';
import { handleSwiperGalleryTurbolinks } from '../modules/swiper_gallery_handler';
import "../modules/stock_inquiry_cart";
import '../modules/select2_init';
import '../modules/category_select';
import '../modules/variant_maker_search_toggle';

// 各モジュールの Turbolinks ハンドラをセットアップ
handleSwiperTurbolinks();
handleMenuTurbolinks();
handlePopupTurbolinks();
handleSwiperGalleryTurbolinks();
